// The browser's own install offer (the "beforeinstallprompt" event) comes once, whenever the browser decides the site is installable -
// often before the late widgets have loaded. It is caught here, as early as the page runs, and kept for the card
// (components/InstallPrompt.tsx) and for the "Install the app" link in the footer (components/InstallAppLink.tsx).

export interface InstallEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

declare global {
  interface Window {
    __recInstall?: InstallEvent | null;
  }
}

export const INSTALL_READY_EVENT = 'rec:install-ready';

export function captureInstallEvent(): () => void {
  const onPrompt = (e: Event) => {
    e.preventDefault();
    window.__recInstall = e as InstallEvent;
    window.dispatchEvent(new Event(INSTALL_READY_EVENT));
  };
  const onInstalled = () => {
    window.__recInstall = null;
    window.dispatchEvent(new Event(INSTALL_READY_EVENT));
  };
  window.addEventListener('beforeinstallprompt', onPrompt);
  window.addEventListener('appinstalled', onInstalled);
  return () => {
    window.removeEventListener('beforeinstallprompt', onPrompt);
    window.removeEventListener('appinstalled', onInstalled);
  };
}

export const getInstallEvent = (): InstallEvent | null => (typeof window === 'undefined' ? null : window.__recInstall ?? null);
